/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchApplicationDetails } from "../../Services/redux/appId-details/AppIdDeatilsActions";
import "../../page/oem-admin/application/info/info.css";
import { Container, Grid2 } from "@mui/material";
import Topheader from "../../Layout/header/header";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ApplicationDetailsSideMenu from "../../Components/ApplicationDetailsSideMenu/ApplicationDetailsSideMenu";
import PopupDialog from "../../Components/PopupDialog";
import { getConfig } from "../../config";

// Helper function to build navigation routes for different portals
const buildBackToApplicationsRoute = (portal, appId, submissionId) => {
  const routes = {
    seller: {
      path: `/ui/developer/applications/${appId}`,
      state: {
        teamId: sessionStorage.getItem("teamId"),
        submissionId: submissionId,
      },
    },
    "domain-approver": {
      path: `/ui/domain-approver/applications/${appId}/submission/${submissionId}`,
    },
    "global-admin": {
      path: `/ui/harman-admin/application/${appId}/submission/${submissionId}`,
    },
  };
  return routes[portal] || null;
};

const QaProcess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const componentName = "";
  const errorMessage = "";
  const headerMessage = "";
  const { appId, submissionId } = useParams();
  const appData = useSelector(
    (state) => state.applicationDetails.applicationDetails
  );
  useEffect(() => {
    dispatch(fetchApplicationDetails(appId));
  }, [appId, dispatch]);

  const backToApplications = () => {
    const routeConfig = buildBackToApplicationsRoute(
      getConfig().REACT_APP_PORTAL,
      appId,
      submissionId
    );
    if (routeConfig) {
      if (routeConfig.state) {
        navigate(routeConfig.path, { state: routeConfig.state });
      } else {
        navigate(routeConfig.path);
      }
    }
  };

  return (
    <>
      <Topheader />
      <Container
        maxWidth="lg"
        sx={{ width: "100% !important", maxWidth: "100% !important" }}
      >
        <Grid2 container>
          <Grid2 size={12}>
            <div className="container-my-release">
              <div
                className="side-menu-my-release"
                style={{ marginTop: "69px" }}
              >
                <button className="arrow-back" onClick={backToApplications} style={{ background: "none", border: "none", cursor: "pointer", padding: 0, display: "flex", alignItems: "center" }}>
                  <div>
                    <ArrowBackIcon style={{ color: " #717273" }} />
                  </div>
                  <div className="my-apps">Back To Applications</div>
                </button>
                {appData && Object.keys(appData).length > 0 && (
                  <ApplicationDetailsSideMenu appData={appData} />
                )}
              </div>

              <div
                className="submission-container-all-release"
                style={{ width: "70%", marginLeft: "22%" }}
              >
                <div className="publisherInfoHeader">
                  <p className="heading">Qa Process</p>
                </div>

                <div className="divForm">
                </div>
              </div>
            </div>
          </Grid2>
        </Grid2>
      </Container>
      <PopupDialog
        openErrorPopup={openErrorPopup}
        errorMessage={errorMessage}
        headerMessage={headerMessage}
        componentName={componentName}
        onClose={() => setOpenErrorPopup(false)}
      />
    </>
  );
};

export default QaProcess;
